export enum PanelResult {
  NOT_SELECTED = 0,
  POSITIVE = 1,
  INCONCLUSIVE = 2,
  NEGATIVE = 3,
}
